import { Component, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from '@azure/msal-browser';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserAuthService } from './services/user-auth/user-auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'ktcs-frontend';
  loginDisplay = false;
  checkLoginStatusSvcSub!: Subscription;

  constructor(
    private readonly authService: MsalService,
    private readonly userAuthSvc: UserAuthService,
    private readonly msalBroadcastService: MsalBroadcastService
  ) {}

  ngOnInit() {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
      });
    this.checkLoginStatusSvcSub = this.userAuthSvc
      .checkLoginStatus()
      .subscribe(() => {
        this.loginDisplay =
          this.authService.instance.getAllAccounts().length > 0;
      });
  }
}
